import PropTypes from 'prop-types';
import 'react';
import { SpacePropType } from '../../../core/types/swan-style.types.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    /**
   * The CSS align-items property sets the align-self value on all direct children as a group. In Flexbox, it controls the alignment of items on the Cross Axis. In Grid Layout, it controls the alignment of items on the Block Axis within their grid area.
   * One of: "stretch", "center", "start", "end", "flex-start", "flex-end", "baseline", "inherit", "initial", "revert", "unset".
   */ alignItems: PropTypes.oneOf([
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'baseline',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    /**
   * The flex-wrap CSS property sets whether flex items are forced onto one line or can wrap onto multiple lines. If wrapping is allowed, it sets the direction that lines are stacked.
   * One of: "nowrap", "wrap", "wrap-reverse", "inherit", "initial", "revert", "unset".
   */ flexWrap: PropTypes.oneOf([
        'nowrap',
        'wrap',
        'wrap-reverse',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    /**
   * The flex-direction CSS property sets how flex items are placed in the flex container defining the main axis and the direction (normal or reversed).
   * One of: "row", "row-reverse", "column", "column-reverse", "inherit", "initial", "revert", "unset".
   */ flexDirection: PropTypes.oneOf([
        'row',
        'row-reverse',
        'column',
        'column-reverse',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    /**
   * The CSS justify-content property defines how the browser distributes space between and around content items along the main-axis of a flex container, and the inline axis of a grid container.
   * One of: "stretch", "center", "start", "end", "flex-start", "flex-end", "left", "right", "normal", "space-between", "space-around", "space-evenly", "inherit", "initial", "revert", "unset".
   */ justifyContent: PropTypes.oneOf([
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'left',
        'right',
        'normal',
        'space-between',
        'space-around',
        'space-evenly',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    /**
   * The gap property places a uniform gap (gutter) between the flex container's children.
   * One of: SWAN spacing units (0 to 13)
   */ gap: PropTypes.oneOf(SpacePropType)
};
const FlexBox = createComponent({
    displayName: 'FlexBox',
    root: 'div',
    propTypes,
    propConfig: {
        classNames: [
            'swan-display-flex'
        ],
        processProps (_param) {
            var { style = {}, alignItems, flexWrap, flexDirection, justifyContent, gap } = _param, props = _object_without_properties(_param, [
                "style",
                "alignItems",
                "flexWrap",
                "flexDirection",
                "justifyContent",
                "gap"
            ]);
            return _object_spread_props(_object_spread({}, props), {
                style: _object_spread_props(_object_spread({}, style), {
                    alignItems: alignItems !== null ? alignItems : undefined,
                    flexWrap: flexWrap !== null ? flexWrap : undefined,
                    flexDirection: flexDirection !== null ? flexDirection : undefined,
                    justifyContent: justifyContent !== null ? justifyContent : undefined,
                    // use != instead of !== to handle `undefined`
                    gap: gap != null ? `var(--swan-spacing-standard-${gap}, var(--swan-sem-space-${gap}))` : undefined
                })
            });
        }
    }
});

export { FlexBox };
